import mapEmergencyTypeToAlertType from '@rsos/base-utils/mapEmergencyTypeToAlertType';

export default mapEmergencyTypeToAlertType;
